module.exports = __webpack_public_path__ + "img/Linguetta_BASE_SX.c5600fee.png";